import TimeNewBanner from "./TimeNewBanner";
import TimeHead from "./TimeHead";
import TimeBody from "./TimeBody";
import Contact from "../Contact/Contact";

export default function TimeNew() {
  return (
    <div>
      <TimeNewBanner />
      <TimeHead />
      <TimeBody />
      <Contact />
    </div>
  );
}
